import {
    Student,
    Student__Legacy,
    StudentStatus,
    UpdateStudentAccountArg,
} from 'src/api/endpoints/students/students.types';
import { baseApi, QueryPayload } from 'src/api';

export type Pageable<T> = {
    content: T[];
    page: {
        size: number;
        number: number;
        totalElements: number;
        totalPages: number;
    };
};

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getStudents: builder.query<
            Pageable<Student__Legacy>,
            {
                params: {
                    branchId: number;
                };
                search?: {
                    statuses?: StudentStatus[];
                    registered?: boolean;
                    groupId?: number;
                    query?: string;
                    page?: number;
                    size?: number;
                };
            }
        >({
            providesTags: ['Student'],
            query: ({ search, params }): QueryPayload => {
                return {
                    url: `/branches/${params.branchId}/students`,
                    method: 'GET',
                    params: search,
                    errorMessage: 'Не удалось получить информацию о студентах!',
                };
            },
        }),

        addStudentAccount: builder.mutation<
            void,
            {
                body: {
                    login: string;
                    password: string;
                    groupId: number;
                    contract: string;
                };
                params: {
                    branchId: number;
                };
            }
        >({
            invalidatesTags: ['Student'],
            query: ({ body, params }): QueryPayload => ({
                url: `/branches/${params.branchId}/students`,
                method: 'post',
                data: body,
                errorMessage: 'Не удалось добавить студента!',
            }),
        }),

        updateStudentAccount: builder.mutation<void, UpdateStudentAccountArg>({
            invalidatesTags: ['Student'],
            query: (arg: UpdateStudentAccountArg): QueryPayload => ({
                url: `students/${arg.studentId}`,
                method: 'PATCH',
                data: {
                    password: arg.password,
                    groupId: arg.curGroup,
                    contract: arg.contract,
                },
                errorMessage: 'Не удалось обновить студента!',
            }),
        }),

        expelStudent: builder.mutation<
            void,
            { expelledAt: number; reason: string; studentId: number }
        >({
            invalidatesTags: ['Student', 'Academic'],
            query: ({ studentId, ...rest }) => ({
                url: `/students/${studentId}/expel`,
                method: 'post',
                data: rest,
                errorMessage: 'Не удалось отчислить студента!',
            }),
        }),

        getStudentById: builder.query<
            Student,
            { params: { branchId: number; studentId: number } }
        >({
            providesTags: (_r, _e, { params }) => [
                { type: 'Branches', id: params.branchId },
                {
                    type: 'Student',
                    id: params.studentId,
                },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetStudentsQuery,
    useAddStudentAccountMutation,
    useUpdateStudentAccountMutation,
    useExpelStudentMutation,
    useGetStudentByIdQuery,
} = api;
